module.exports = __webpack_public_path__ + "media/images/payment-1-29006dfd2ddc29ee5b3325e11fe39e91.svg";